import React from "react";

function ResubmitionYellowIcon() {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="45" cy="45" r="45" fill="#FFFED8" />
      <circle cx="45.0006" cy="45.0006" r="32.1429" fill="#FEF9C3" />
      <path
        d="M45.3493 29.5348C53.698 29.5348 60.4656 36.3039 60.4656 44.6511C60.4656 52.9983 53.698 59.7673 45.3493 59.7673C37.0006 59.7673 30.233 52.9983 30.233 44.6511C30.233 36.3039 37.0006 29.5348 45.3493 29.5348ZM45.3493 32.0547C38.4034 32.0547 32.7529 37.7051 32.7529 44.6511C32.7529 51.597 38.4034 57.2475 45.3493 57.2475C52.2952 57.2475 57.9457 51.597 57.9457 44.6511C57.9457 37.7051 52.2952 32.0547 45.3493 32.0547ZM45.3478 48.4332C45.7483 48.4332 46.1324 48.5923 46.4156 48.8755C46.6988 49.1587 46.8579 49.5428 46.8579 49.9433C46.8579 50.3438 46.6988 50.7279 46.4156 51.0111C46.1324 51.2943 45.7483 51.4534 45.3478 51.4534C44.9473 51.4534 44.5632 51.2943 44.28 51.0111C43.9968 50.7279 43.8377 50.3438 43.8377 49.9433C43.8377 49.5428 43.9968 49.1587 44.28 48.8755C44.5632 48.5923 44.9473 48.4332 45.3478 48.4332ZM45.3402 37.0929C45.6144 37.0926 45.8795 37.1916 46.0863 37.3717C46.2931 37.5518 46.4276 37.8008 46.4649 38.0725L46.4754 38.2251L46.4815 45.0305C46.4818 45.3179 46.3729 45.5946 46.177 45.8048C45.981 46.015 45.7125 46.1429 45.4258 46.1627C45.1391 46.1825 44.8556 46.0926 44.6326 45.9114C44.4096 45.7301 44.2638 45.4709 44.2246 45.1862L44.214 45.032L44.208 38.2282C44.2078 38.0792 44.237 37.9316 44.2939 37.7938C44.3508 37.6561 44.4342 37.531 44.5395 37.4255C44.6448 37.3201 44.7699 37.2364 44.9075 37.1794C45.0452 37.1223 45.1912 37.0929 45.3402 37.0929Z"
        fill="#854D0E"
      />
    </svg>
  );
}

export default ResubmitionYellowIcon;
